import script from "./MobileNumber.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileNumber.vue?vue&type=script&setup=true&lang=js"

import "./MobileNumber.vue?vue&type=style&index=0&id=1d6833b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d6833b8"]])

export default __exports__